import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.regexp.replace.js";
import { useCallback, useContext, useEffect, useState } from 'react'; // @ts-expect-error: No type yet

import { AnalyticsContext } from '@nerdwallet/analytics/react'; // @ts-expect-error: No type yet

import { ImpressionContext } from '@nerdwallet/analytics/react/impression';

var useCallbackChain = function useCallbackChain(method, callback) {
  return useCallback(function () {
    method.apply(void 0, arguments);
    if (callback) callback.apply(void 0, arguments);
  }, [method, callback]);
};

var buildEntityName = function buildEntityName(entityName) {
  return entityName.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};

export var useElementInteraction = function useElementInteraction(_ref) {
  var _ref$enable = _ref.enable,
      enable = _ref$enable === void 0 ? true : _ref$enable,
      visible = _ref.visible,
      entityName = _ref.entityName,
      eventType = _ref.eventType,
      eventPayload = _ref.eventPayload,
      onClickProp = _ref.onClick,
      onFocusProp = _ref.onFocus,
      onBlurProp = _ref.onBlur;
  var analytics = useContext(AnalyticsContext);
  var impressionContext = useContext(ImpressionContext);
  var impressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId; // stores last interaction type

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      prevInteractionType = _useState2[0],
      setPrevInteractionType = _useState2[1]; // updates the interactionType whenever user interacts with interface


  var updateInteractionType = useCallback(function (interactionType) {
    // update interaction type in state, waiting until visibility change to fire event
    setPrevInteractionType(interactionType);
  }, []); // wait for change to `visible` prop to fire events

  var _useState3 = useState(visible),
      _useState4 = _slicedToArray(_useState3, 2),
      prevVisible = _useState4[0],
      setPrevVisible = _useState4[1];

  useEffect(function () {
    if (!enable) return undefined; // bail if visibility value hasn't changed

    if (visible === prevVisible) return undefined; // immediately update prev visible state

    setPrevVisible(visible); // fire the event

    var payload = {
      action: visible ? 'open' : 'close',
      entity_name: buildEntityName(entityName),
      interaction_type: prevInteractionType,
      impression_id: impressionId
    }; // If eventType is defined we should fire that event (i.e: help_bubble_interacted) and not the default element_interacted

    analytics.track(eventType || 'element_interacted', // passing extra event info to payload
    _typeof(eventPayload) === 'object' ? _objectSpread(_objectSpread({}, payload), eventPayload) : payload);
    return undefined;
  }, [enable, visible, prevVisible, prevInteractionType, entityName, eventType, eventPayload, analytics, impressionId]); // spread the output of this hook on the target component

  return {
    onClick: useCallbackChain(function () {
      return updateInteractionType('press');
    }, onClickProp),
    onFocus: useCallbackChain(function () {
      return updateInteractionType('focus');
    }, onFocusProp),
    onBlur: useCallbackChain(function () {
      return updateInteractionType('blur');
    }, onBlurProp) // not attaching mouseover or mouseout, this component has no hoverability
    // not attaching onKeydown, because reakit uses keydown binding to fire click events, so the click follows the keydown, so interactionType is always 'click'

  };
};